import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

type ShoppingBagNotificationMessageProps = {
    mainTemplate: string
    fallbackTemplate: string
    children: string
}

// Todo: User Story 460682 - Theming techdebt: This templated component values for text-transform property can be removed.
// https://dev.azure.com/Next-Technology/Ecom.Backlog/_workitems/edit/460682
// Text transform is to come from typography obj in theme/mui tyography component.

export const ShoppingBagNotificationMessage = memo(
    ({mainTemplate, fallbackTemplate, children}: ShoppingBagNotificationMessageProps) => {
        const ComponentName = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)

        return (
            <Suspense>
                <ComponentName component="h4" data-testid="header-shopping-bag-notification-message">
                    {children}
                </ComponentName>
            </Suspense>
        )
    },
)
ShoppingBagNotificationMessage.displayName = "ShoppingBagNotificationMessage"

export default connect(ShoppingBagNotificationMessage)
